/**
 * Normalização de termo para casamento — remove diacrítico e caixa.
 *
 * Mora em módulo PRÓPRIO, e não dentro de um consumidor, pela mesma razão que
 * `useDebounced`: utilitário compartilhado dentro de um consumidor faz qualquer
 * teste que mocke aquele módulo derrubar tudo que o importa. Aconteceu duas
 * vezes nesta frente antes de eu aprender.
 *
 * O range de marcas combinantes vai como escape textual (Combining Diacritical
 * Marks, U+0300 a U+036F): marca crua no fonte é invisível no editor e sobrevive
 * mal a formatador.
 */
export function foldTerm(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}
